import CreateMPConfirmModal from "./CreateMPConfirm";
import AuthCard from "./AuthCard";

const authComponents = {
  CreateMPConfirmModal,
  AuthCard
}

export default authComponents